import { render, staticRenderFns } from "./ModificaPrenotazione.vue?vue&type=template&id=18922376&scoped=true&"
import script from "./ModificaPrenotazione.vue?vue&type=script&lang=js&"
export * from "./ModificaPrenotazione.vue?vue&type=script&lang=js&"
import style0 from "./ModificaPrenotazione.vue?vue&type=style&index=0&id=18922376&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18922376",
  null
  
)

export default component.exports